import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const conjunto = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
}
